// Initialize form features
jQuery(document).on('elementor/popup/show', function (event, popup) {
    setTimeout(function () {
        const formContainer = document.querySelector('.elementor-popup-modal .ctct-inline-form');
        if (formContainer && typeof window.ctctOnLoadCallback === 'function') {
            window.ctctOnLoadCallback();
        }
    }, 500);
});